import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { AuthService } from "src/app/common/services/auth/auth.service";
import { environment } from "src/environments/environment";

declare global {
    interface Window {
        pendo: any;
    }
}

@Injectable({
  providedIn: 'root',
})
export class PendoService {
  private readonly enabled = environment.pendoEnabled;
  private readonly isLocalhost =
    location.hostname === 'localhost' || location.hostname === '127.0.0.1';
  // private readonly isLocalhost = false;
  private initialized = false;

  constructor(private router: Router, private authService: AuthService) {
    if (this.shouldEnable()) {
      this.listenToRouter();
    }
  }

  private shouldEnable(): boolean {
    return this.enabled && !this.isLocalhost && typeof window.pendo !== 'undefined';
  }

  initialize(
    userName: string,
    metadata: {
      role?: string;
      hubName?: string;
    }
  ): void {
    try {
      if (!this.shouldEnable() || !userName || this.initialized) return;

      const data = {
        visitor: {
          id: userName,
          role: metadata.role,
        },
        account: {
          id: userName,
          accountName: userName,
          hubName: metadata.hubName,
        },
      };
      window.pendo.initialize(data);

      this.initialized = true;
      console.log('Pendo initialized', data);
    } catch (error) {
      console.error(`Error initializing Pendo:`, error);
    }
  }

  track(eventName: string): void {
    try {
      if (!this.shouldEnable()) return;
      const currentUser = this.authService.getCurrentUser();
      const data = {
        accountId: currentUser.userName,
        timestamp: Date.now(),
        hubName: currentUser.hubName,
      };
      window.pendo.track?.(eventName, data);
      console.log(`Pendo tracked`, eventName);
    } catch (error) {
      console.error(`Error tracking event with Pendo - ${eventName}:`, error);
    }
  }

  pageLoad(): void {
    try {
      if (!this.shouldEnable()) return;
      window.pendo.pageLoad?.();
    } catch (error) {
      console.error(`Error tracking page load with Pendo:`, error);
    }
  }

  validateInstall(): void {
    try {
      if (!this.shouldEnable()) return;
      window.pendo.validateInstall?.();
    } catch (error) {
      console.error(`Error tracking validate install with Pendo:`, error);
    }
  }

  private listenToRouter(): void {
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
      this.pageLoad();
    });
  }
}